module.exports = __webpack_public_path__ + "media/images/product-banners/small-change-b8320ec9a3a4adae578e8e412104a10c.svg";